import { motion } from "framer-motion";
import { Rocket } from "lucide-react";

export default function Mission() {
  return (
    <section data-testid="mission-section" className="py-24 md:py-32 bg-dark-card relative overflow-hidden">
      {/* Background Pattern */}
      <div className="absolute inset-0 opacity-5">
        <div
          className="w-full h-full"
          style={{
            backgroundImage: `radial-gradient(circle at 50% 50%, #BAF265 1px, transparent 1px)`,
            backgroundSize: "40px 40px",
          }}
        />
      </div>

      <div className="max-w-5xl mx-auto px-6 text-center relative z-10">
        <motion.div
          initial={{ opacity: 0, scale: 0.9 }}
          whileInView={{ opacity: 1, scale: 1 }}
          viewport={{ once: true }}
          transition={{ duration: 0.6 }}
        >
          <div className="inline-flex items-center gap-2 bg-lime/10 px-4 py-2 mb-8">
            <Rocket className="w-4 h-4 text-lime" />
            <span className="font-body text-sm text-lime font-medium">OUR MISSION</span>
          </div>

          <h2
            data-testid="mission-title"
            className="font-heading font-bold text-3xl md:text-4xl lg:text-5xl uppercase text-white leading-tight"
          >
            To help ambitious businesses grow faster through{" "}
            <span className="text-lime">content that performs</span>,{" "}
            <span className="text-lime">strategy that converts</span>, and{" "}
            <span className="text-lime">systems that scale</span>.
          </h2>
        </motion.div>

        {/* Not Just Another Agency */}
        <motion.div
          initial={{ opacity: 0, y: 30 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.6, delay: 0.2 }}
          className="mt-20 pt-16 border-t border-white/10"
        >
          <h3
            data-testid="agency-tagline"
            className="font-heading font-bold text-2xl md:text-3xl uppercase text-white mb-4"
          >
            Not Just Another Agency.
          </h3>
          <p className="font-body text-lg text-lime font-medium">
            We're your unfair advantage.
          </p>
        </motion.div>
      </div>
    </section>
  );
}
